import { useTranslation } from 'react-i18next'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { NewsroomSettingsSheet } from '../NewsroomSettingsSheet'

type NewsroomPageToolbarProps = {
  settingsOpen: boolean
  onSettingsOpenChange: (open: boolean) => void
  includeDismissed: boolean
  onIncludeDismissedChange: (checked: boolean) => void
}

export function NewsroomPageToolbar({
  settingsOpen,
  onSettingsOpenChange,
  includeDismissed,
  onIncludeDismissedChange,
}: NewsroomPageToolbarProps) {
  const { t } = useTranslation('regulatory-alerts')

  return (
    <div className='flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
      <div>
        <h1 className='text-2xl font-bold tracking-tight'>{t('page.title')}</h1>
        <p className='text-muted-foreground'>{t('page.description')}</p>
      </div>
      <div className='flex flex-wrap items-center gap-2'>
        <NewsroomSettingsSheet
          open={settingsOpen}
          onOpenChange={onSettingsOpenChange}
        />
        <Switch
          id='show-dismissed'
          checked={includeDismissed}
          onCheckedChange={onIncludeDismissedChange}
        />
        <Label htmlFor='show-dismissed'>{t('inbox.showDismissed')}</Label>
      </div>
    </div>
  )
}
